import React from 'react'
import Title from 'shared/components/Title'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import { Link } from 'react-router-dom'
import { Container, Divider } from 'semantic-ui-react'
import Page from 'shared/components/Page'

export default function InvalidPasswordToken() {
  return (
    <Page>
      <AuthenticationShell
        headerText={
          <>
            <i className="icon far fa-ban" /> Invalid token
          </>
        }
      >
        <Title title="Invalid token" />
        <Container textAlign="center">
          <p className="content-text">
            This password reset token is invalid.
            <br />
            Please <Link to="/reset-password">request another token</Link>.
          </p>
          <Divider hidden />
          <Link to={{ pathname: '/login/', search: location.search }}>
            <i className="fas fa-arrow-left icon" />
            Back to login
          </Link>
        </Container>
      </AuthenticationShell>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ResetPassword/InvalidPasswordToken.js